import { render } from "./puzzle.vue?vue&type=template&id=35ae404e&scoped=true"
import script from "./puzzle.vue?vue&type=script&lang=js"
export * from "./puzzle.vue?vue&type=script&lang=js"

import "./puzzle.vue?vue&type=style&index=0&id=35ae404e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ae404e"]])

export default __exports__